import providerService from '@/services/provider.service';

import {
  SET_ALL_PROVIDERS,
  SET_PROVIDER,

  SET_PROFILE_PIC,
} from './type.mutation';

const state = {
  all: [],
  providersMappedById: {},
  selectedProvider: null,
  providersMappedByUserId: {},
};

/* eslint-disable no-param-reassign */
const mutations = {
  [SET_ALL_PROVIDERS](_state, { providers, mappedById, mappedByUserId }) {
    _state.all = providers;
    _state.providersMappedById = mappedById;
    _state.providersMappedByUserId = mappedByUserId;
  },
  [SET_PROVIDER](_state, payload) {
    _state.selectedProvider = payload ? { ...payload } : null;
  },
  [SET_PROFILE_PIC](_state, payload) {
    _state.selectedProvider = {
      ...(_state.selectedProvider),
      profilePicKey: payload.profilePicKey || '',
      profilePicURL: payload.profilePicURL || '',
    };
  },
};

const actions = {
  fetchAllProviders({ commit }, param = {}) {
    return providerService.fetchAll(param)
      .then(response => {
        // Using Map to optimize data processing
        const mappedById = new Map();
        const mappedByUserId = new Map();

        const providers = response.data || [];

        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < providers.length; i++) {
          const provider = providers[i];
          mappedById.set(provider._id, provider);
          mappedByUserId.set(provider.user, provider);
        }

        commit(SET_ALL_PROVIDERS, {
          providers,
          mappedById: Object.fromEntries(mappedById),
          mappedByUserId: Object.fromEntries(mappedByUserId)
        });

        return providers;
      })
      .catch(error => {
        console.error('fetchAllProviders error:', error);
        throw error;
      });
  },
  resetAll({ commit }) {
    commit(SET_ALL_PROVIDERS, {
      providers: [],
      mappedById: {},
      mappedByUserId: {},
    });
  },
  setSelectedProvider({ commit }, payload) {
    commit(SET_PROVIDER, payload);
  },
  unsetSelectedProvider({ commit }) {
    commit(SET_PROVIDER, null);
  },
  createNewProvider({ commit }, payload) {
    commit('setLoading', true, { root: true });
    return providerService.create(payload)
      .then((response) => {
        if (response.success) {
          commit(SET_PROVIDER, response.data);
        }
        commit('setLoading', false, { root: true });
        return response;
      });
  },
  updateProfilePic({ commit }, { providerId, file }) {
    return providerService.updateProviderProfilePic(providerId, file)
      .then((response) => {
        if (response.ok) {
          commit(SET_PROFILE_PIC, response.data);
        }
        return response;
      });
  },
  updateProvider({ commit }, payload) {
    commit('setLoading', true, { root: true });
    return providerService.update(payload._id, payload)
      .then((response) => {
        if (response.success) {
          commit(SET_PROVIDER, response.data);
        }
        commit('setLoading', false, { root: true });
        return response;
      });
  },
  deleteProvider({ commit }, payload) {
    commit('setLoading', true, { root: true });
    return providerService.delete(payload._id)
      .then((response) => {
        if (response.success) {
          commit(SET_PROVIDER, null);
          localStorage.removeItem('providerFilters');
          localStorage.removeItem('therapistFilters');
          localStorage.removeItem('consultantFilters');
        }
        commit('setLoading', false, { root: true });
        return response;
      });
  },
  getByClinicId({ commit }, { ids }) {
    commit('setLoading', true, { root: true });
    return providerService.getByClinicId({ ids })
      .then((response) => {
        commit('setLoading', false, { root: true });
        return response;
      });
  },
};

const getters = {
  all: _state => _state.all,
  providersOptionMap: _state => (_state.all || [])
    .filter(p => !p.isDeleted)
    .map(provider => ({
      value: provider._id,
      text: provider.name,
    })),
  doctorsOptionMap: _state => _state.all
    .filter(doctor => doctor.role === 'provider' && !doctor.isDeleted)
    .map(doctor => ({
      value: doctor._id,
      text: doctor.name,
    })),
  therapistOptionMap: _state => _state.all
    .filter(doctor => doctor.role === 'therapist' && !doctor.isDeleted)
    .map(doctor => ({
      value: doctor._id,
      text: doctor.name,
    })),
  consultantOptionMap: _state => _state.all
    .filter(doctor => doctor.role === 'consultant' && !doctor.isDeleted)
    .map(doctor => ({
      value: doctor._id,
      text: doctor.name,
    })),
  selectedProvider: _state => _state.selectedProvider,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
